module.exports = __webpack_public_path__ + "img/keyboard_B.6877f50c.png";